<template>
  <el-card class="box-card mb-50 box-search">
    <span class="tilte-search mb-10">{{ $t('shops.index.search') }}</span>
    <el-form ref="formSearch" @submit.prevent="search" :model="dataSearch" v-if="this.role !== this.$userRole.partner.shop">
      <el-form-item prop="name">
        <el-input :placeholder="$t('shops.shop_name')" v-model="dataSearch.name"/>
      </el-form-item>
      <el-form-item prop="filters[0][data]">
        <el-select
            slot="prepend"
            v-model="dataSearch['filters[0][data]']"
            style="width: 100%;"
            :placeholder="$t('shops.select_genre')"
        >
          <el-option v-for="item in listGenre" :label="item.name" :key="item.id" :value="item.id"/>
        </el-select>
      </el-form-item>
      <div class="mt-20 mb-25">
        <el-button type="danger" class="btn-search" @click="search" @keyup.enter.native="search">{{
            $t('btn_search')
          }}
        </el-button>
        <el-button type="info" class="btn-clear" @click="resetForm">{{ $t('btn_clear') }}</el-button>
      </div>
    </el-form>
    <table-data
      :data="data" :loading="loading" :columns="columns" :buttons="buttons" :hasCreate="hasCreate"
      @change-page="handleChangePage"
      @click-button="handleClickButtonTable"
      @handle-redirect-create="redirectCreate"
      @sort="sort">
    </table-data>
  </el-card>
</template>
<script>
import {getListData} from '../../api/shop'
import {getListGenre} from '../../api/genre'

export default {
  props: {
    urls: { type: Object, required: true, default: {} },
    role: { type: Number, required: false }
  },

  data() {
    return {
      formSearch: {
        name: "",
      },
      data: {},
      listGenre: [],
      loading: true,
      listQuery: {
        page: 1,
        name: "",
        filter: "",
        "filters[0][key]": "genre_id",
        "filters[0][data]": "",
        "filters[1][key]": "company_id",
        "filters[1][data]": "",
      },
      columns: [
        {prop: "name", label: "所属名", sortable: "custom", class: ""},
        {prop: "genre_name", label: "ジャンル", sortable: "custom", class: "text-center", width: "170"},
        {prop: "status", label: "ステータス", sortable: "custom", class: "", width: "150"},
        {prop: "last_login_datetime", label: "最終ログイン日", sortable: "custom", class: "", width: "145"}
      ],
      buttons: [
        {id: "1", label: "選択", type: "select", class: "btn btn-select"},
        {id: "2", label: "詳細", type: "detail", class: "btn btn-detail"}
      ],

      sortProp: {key: 'status', dir: 'descending'},
      hasCreate: true,
      dataSearch: {
        page: 1,
        name: "",
        filter: "",
        "filters[0][key]": "genre_id",
        "filters[0][data]": "",
        "filters[1][key]": "company_id",
        "filters[1][data]": ""
      }
    }
  },

  methods: {
    getListData() {
      const query = {...this.listQuery, ...this.sortProp}
      getListData(query)
        .then(response => response.json())
        .then(response => {
          response.data.records = response.data.records.map(e => {
            return {
              ...e,
              status: this.convertStatus(e.status, e.status_name),
              is_display: e.is_display == '1' ? `<span>${this.$t('shops.show')}</span>` : `<span style="color: #AC3B29;">${this.$t('shops.hide')}</span>`
            }
          })
          this.data = response.data;
          this.loading = false;
        })
        .catch((error) => {
        })
        .finally(() => {

        });
    },

    handleChangePage(page) {
      this.loading = true;
      this.listQuery.page = page;
      this.getListData();
    },

    search() {
      this.loading = true;
      this.listQuery = Object.fromEntries(Object.entries(this.dataSearch).map(([k, v]) => [k, v]));
      this.listQuery.page = 1;
      this.getListData();
    },

    handleClickButtonTable(type, row) {
      switch (type) {
        case 'select':
          window.location.href = "/staff?shop_id=" + row.id;
          break;
        case 'detail':
          window.location.href = "/shops/" + row.id;
          break;
      }
    },

    sort(sortProps) {
      this.sortProp = {key: sortProps.prop, dir: sortProps.order};
      this.listQuery.page = 1;
      this.getListData();
    },

    resetForm() {
      this.dataSearch = {
        page: 1,
        name: "",
        filter: "",
        "filters[0][key]": "genre_id",
        "filters[0][data]": "",
        "filters[1][key]": "company_id",
        "filters[1][data]": ""
      };
      if (!this.role || this.role == this.$userRole.admin ) {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        if (urlParams.get('company_id')) {
          this.dataSearch['filters[1][data]'] = urlParams.get('company_id');
        }
      }
    },

    getListGenre(page = 1) {
      getListGenre(page, this.formSearch.name, this.sortProp)
        .then(response => response.json())
        .then(response => {
          this.listGenre = response.data;
        })
        .catch((error) => {
        })
        .finally(() => {

        });
    },

    convertStatus(statusCode, statusName) {
      if (statusCode === 0) {
        return `<p class="status-inactive"> ${statusName}</p>`;
      } else if (statusCode === 1) {
       return `<p class="status-active"> ${statusName}</p>`;
      } else {
        return `<p class="status-pending"> ${statusName}</p>`;
      }
    },

    redirectCreate() {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      let params = '';
      if ((!this.role || this.role == this.$userRole.admin) && urlParams.get('company_id') ) {
        params = `?company_id=${urlParams.get('company_id')}`;
      }

      window.location.href = this.urls.create + params;
    }
  },

  watch: {
    filter() {
      this.handleFilter()
    }
  },
  created() {
    if (!this.role || this.role == this.$userRole.admin ) {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      if (urlParams.get('company_id')) {
        this.listQuery['filters[1][data]'] = urlParams.get('company_id');
        this.dataSearch['filters[1][data]'] = urlParams.get('company_id');
      }
      this.columns.splice(3,0, {prop: "is_display", label: "表示・非表示", class: "", width: "130"});
    }
    if (this.role == this.$userRole.partner.shop ) {
      this.hasCreate = false;
    }

    this.getListData();
    this.getListGenre();
  },
  handleFilter() {
    this.listQuery.page = 1
    this.getList({...this.listQuery, ...this.filterData})
  },
  getList(param) {

  }
}
</script>
